import { createReducer, on } from '@ngrx/store';

import { Session } from '@core/models/session.interface';
import { SessionActions, SessionEffectsActions } from '../actions/session.actions';

export const initialState: Session = {
  user: { } as any
};

export const sessionReducer = createReducer(
  initialState,
  on(SessionActions.injectUser, (_state, { user }) => ({
    ..._state, user
  })),
  on(SessionEffectsActions.ejectUser, (_state ) => ({
    ..._state, user: null
  })),
  // on(SessionActions.success, (_state, { petition }) => ({
  //   petitions: [ ..._state.petitions, petition ],
  //   loading: false
  // })),
  // on(SessionActions.error, (_state, { petition }) => ({
  //   petitions: [ ..._state.petitions, petition ],
  //   loading: false
  // })),
);
